import { render } from "./AllRowdyList.vue?vue&type=template&id=0b097a17&scoped=true"
import script from "./AllRowdyList.vue?vue&type=script&lang=js"
export * from "./AllRowdyList.vue?vue&type=script&lang=js"

import "./AllRowdyList.vue?vue&type=style&index=0&id=0b097a17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b097a17"]])

export default __exports__